export default "__VITE_ASSET__BJMsexgE__"